import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import { metaData } from 'interfaces/interfaces';

interface SEOTypes {
  description: string;
  lang: string;
  meta: {
    name: string;
    content: string;
    property?: undefined;
  };
  title: string;
}

function SEO({ description, lang, meta, title }: SEOTypes) {
  const data: metaData = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteTitle
            siteDescription
            author
          }
        }
      }
    `
  );

  const metaDescription = description || data.site.siteMetadata.siteDescription;
  const defaultTitle = data.site.siteMetadata?.siteTitle;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      link={[
        {
          type: `text/css`,
          rel: `stylesheet`,
          href: `https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css`,
        },
      ]}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : undefined}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: data.site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default SEO;
